import React from 'react';
import { isTabKeepAliveEnabled } from '../config/tabKeepAlive';

interface ProtectedRouteElementProps {
  children: React.ReactNode;
}

/**
 * Quando keep-alive está ativo, o React Router não renderiza a página no Outlet
 * (TabKeepAliveOutlet cuida disso). Caso contrário, renderiza normalmente.
 */
export const ProtectedRouteElement: React.FC<ProtectedRouteElementProps> = ({ children }) => {
  if (isTabKeepAliveEnabled()) {
    return null;
  }

  return <>{children}</>;
};
